/* eslint-disable radix */
import {
  concat, findIndex, insert, merge, propEq, reject
} from 'ramda';
import {
  POST_JOB_PROFILE_REQUEST_FAIL, POST_JOB_PROFILE_REQUEST, POST_JOB_PROFILE_REQUEST_SUCCESS,
  LOAD_JOB_PROFILES_FAIL, LOAD_JOB_PROFILES_REQUEST, LOAD_JOB_PROFILES_SUCCESS,
  DELETE_JOB_PROFILE_FAIL, DELETE_JOB_PROFILE_REQUEST, DELETE_JOB_PROFILE_SUCCESS,
  PUT_JOB_PROFILE_FAIL, PUT_JOB_PROFILE_REQUEST, PUT_JOB_PROFILE_SUCCESS,
  LOAD_WORK_EFFORT_TYPES_REQUEST, LOAD_WORK_EFFORT_TYPES_SUCCESS, LOAD_WORK_EFFORT_TYPES_FAIL
} from 'src/store/actions/jobProfilesActions';

const initialState = {
  list: [],
  fetching: false,
  errors: [],
  workEffortTypes: [],
  workEffortTypesOptions: []
};

const workEffortsToOptions = (list) => list.map(({
  WorkEffortTypeId,
  WorkEffortTypeName
}) => ({
  label: WorkEffortTypeName,
  value: WorkEffortTypeId
}));

const addOrReplaceInList = (filter, prop, list) =>
  // concat([filter], reject(propEq(prop, filter[prop]), list)); // if it exists, then add it to the list but remove old value first.
  // eslint-disable-next-line implicit-arrow-linebreak
  insert(findIndex(propEq(prop, filter[prop]), list), filter, reject(propEq(prop, filter[prop]), list));

const jobProfilesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_JOB_PROFILES_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_JOB_PROFILES_SUCCESS:
      return merge(state, { list: action.list, fetching: false });
    case LOAD_JOB_PROFILES_FAIL:
      return merge(state, { errors: action.error, fetching: false });
    case POST_JOB_PROFILE_REQUEST_FAIL:
      return merge(state, { errors: action.error, fetching: false });
    case POST_JOB_PROFILE_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case POST_JOB_PROFILE_REQUEST_SUCCESS:
      return merge(state, {
        list: concat(state.list, action.data),
        fetching: false,
        errors: []
      });
    case DELETE_JOB_PROFILE_REQUEST:
      return merge(state, { fetching: true });
    case DELETE_JOB_PROFILE_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case DELETE_JOB_PROFILE_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        list: reject(propEq('JobProfileId', parseInt(action.jobProfileId)), state.list)
      });
    case PUT_JOB_PROFILE_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case PUT_JOB_PROFILE_SUCCESS:
      return merge(state, {
        fetching: false,
        errors: [],
        list: addOrReplaceInList(action.data, 'JobProfileId', state.list)
      });
    case PUT_JOB_PROFILE_FAIL:
      return merge(state, { errors: action.error, fetching: false });
    case LOAD_WORK_EFFORT_TYPES_SUCCESS:
      return merge(state, { workEffortTypes: action.list, workEffortTypesOptions: workEffortsToOptions(action.list) });
    default:
      return state;
  }
};

export default jobProfilesReducer;
